import axios from 'axios'

const api = axios.create({
  baseURL: 'https://fantasticafabricadesites.com.br/bamboleio-report/api'
})

export default api
